import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DevicesService {
  deviceUpdate = new BehaviorSubject(null);
  devices = [];
  selectedDevice: any;
  constructor(private http: HttpService) {}

  getDevice() {
    return this.http.doGet('/devices', {});
  }

  setCurrentDevice(device: any) {
    this.selectedDevice = device;
    this.deviceUpdate.next(device);
  }
}
